<div
    class="d-flex mb-20 justify-content-between flex-column flex-md-row gradient position-relative"
>
    <div
        class="container"
        *ngIf="
            'hero-card-message-' + communityService.communityCode
                | cmsText
                | async
        "
    >
        <div class="row">
            <div class="col-12 col-lg-6 col-md-7">
                <div class="mw-md">
                    <div class="pt-4 pt-md-5 pb-md-3 pe-md-5">
                        <h1
                            [innerHTML]="'hero-card-title' | cmsText | async"
                        ></h1>
                        <h6 class="fw-normal">
                            <span
                                >{{
                                    'participant-count-title'
                                        | cmsText
                                            : [
                                                  {
                                                      participantCount:
                                                          (participantCount$
                                                          | async
                                                          | number),
                                                  },
                                              ]
                                        | async
                                }}
                            </span>
                            <span
                                class="d-inline-block"
                                [innerHTML]="
                                    'participant-count-text' | cmsText | async
                                "
                            ></span>
                        </h6>
                    </div>
                    <div class="container pb-md-5 pt-2 px-0">
                        <div class="row">
                            <div
                                class="col-12 col-lg-10 col-xl-10 col-xxl-8 col-md-12"
                            >
                                <app-register-btns></app-register-btns>
                            </div>
                        </div>
                    </div>
                    <div class="pb-3 pb-md-5">
                        <ul class="fa-ul ms-0">
                            <li class="m-1">
                                <p>
                                    <i class="fa fa-check"></i>
                                    <app-content
                                        class="ms-3"
                                        key="why-signup-bullet-1-text"
                                    ></app-content>
                                </p>
                            </li>
                            <li class="m-1">
                                <p>
                                    <i class="fa fa-check"></i>
                                    <app-content
                                        class="ms-3"
                                        key="why-signup-bullet-2-text"
                                    ></app-content>
                                </p>
                            </li>
                            <li class="m-1">
                                <p>
                                    <i class="fa fa-check"></i>
                                    <app-content
                                        class="ms-3"
                                        key="why-signup-bullet-3-text"
                                    ></app-content>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="hero-img-position col-lg-6 col-md-5 col-12">
            <div
                class="img-fluid w-100 h-100 hero-image"
                [ngStyle]="{ 'background-image': 'url(' + hero + ')' }"
            ></div>
        </div>
    </div>
</div>
